import { Alert, Box, DialogContent } from "@mui/material";
import { useAppSelector } from "app/hooks";
import settings from "app/settings";
import { Button, ButtonGroup, FilePreview, Spacer } from "common";
import { selectAccessToken } from "features/identity/identitySlice";
import { useState } from "react";
import WaiverSubmitForm from "./submit/WaiverSubmitForm";
import WaiverSubmitProvider from "./submit/WaiverSubmitProvider";
import { WaiverFormItem } from "./waiverApi";

export interface WaiverPreviewProps {
  item: WaiverFormItem;
  isDirty?: boolean;
}

export default function WaiverPreview({ item, isDirty }: WaiverPreviewProps) {
  const accessToken = useAppSelector(selectAccessToken);
  const [previewMode, setPreviewMode] = useState<
    "mobile" | "desktop" | "tablet" | "pdf"
  >("desktop");
  let w = "800px";
  if (previewMode === "tablet") {
    w = "600px";
  }
  if (previewMode === "mobile") {
    w = "400px";
  }

  return (
    <>
      {isDirty && previewMode === "pdf" && (
        <Alert severity="warning" sx={{ alignSelf: "center", mb: 2 }}>
          Changes not saved — the preview shows the saved state.
        </Alert>
      )}
      <Box
        sx={{
          justifyContent: "center",
          //backgroundColor: "red",
          display: "flex",
          gap: 4,
        }}
      >
        <ButtonGroup
          value={previewMode}
          onChange={(evt: any) => {
            setPreviewMode(evt.target.value as any);
          }}
          options={[
            { value: "desktop", label: "Desktop" },
            { value: "tablet", label: "Tablet" },
            { value: "mobile", label: "Mobile" },
          ]}
        />
        <Button
          title="PFD"
          variant={previewMode === "pdf" ? "contained" : "outlined"}
          onClick={(evt: any) => {
            setPreviewMode("pdf");
          }}
        />
      </Box>
      <Spacer h={2} />
      {previewMode === "pdf" ? (
        <Box
          sx={{
            justifyContent: "center",
            //backgroundColor: "red",
            display: "flex",
            gap: 4,
          }}
        >
          <Box sx={{ maxWidth: "600px" }}>
            <FilePreview
              url={`${settings.apiHost}/waivers/preview/${item.id}?accessToken=${accessToken}`}
              title={item.name}
              fileName={`${item.name}.pdf`}
              type="pdf"
            />
          </Box>
        </Box>
      ) : (
        <DialogContent sx={{ minWidth: w, maxWidth: w, justifySelf: "center" }}>
          <WaiverSubmitProvider previewItem={item} key={item.id}>
            <WaiverSubmitForm forceMobile={previewMode === "mobile"} />
          </WaiverSubmitProvider>
        </DialogContent>
      )}
    </>
  );
}
